import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const BellIcon = (props: IconProps) => (
  <Icon width="18px" height="18px" viewBox="0 0 18 18" {...props}>
    <path d="M5.685 3.06 4.612 1.987a7.819 7.819 0 0 0-3.09 5.888h1.5A6.334 6.334 0 0 1 5.685 3.06Zm9.293 4.815h1.5a7.866 7.866 0 0 0-3.09-5.888L12.321 3.06a6.371 6.371 0 0 1 2.655 4.815ZM13.5 8.25c0-2.303-1.23-4.23-3.375-4.74V3c0-.623-.503-1.125-1.125-1.125-.623 0-1.125.502-1.125 1.125v.51C5.722 4.02 4.5 5.94 4.5 8.25V12L3 13.5v.75h12v-.75L13.5 12V8.25ZM9 16.5c.105 0 .202-.008.3-.03a1.522 1.522 0 0 0 1.08-.885c.075-.18.112-.375.112-.585h-3A1.51 1.51 0 0 0 9 16.5Z" />
  </Icon>
);

export default memo(BellIcon);
